import React from 'react';
import { IProps as IBlockProps } from '@/blocks/ContactInfoBlock/ContactInfoBlock.interface';
import ContactInfoBlock from '@/blocks/ContactInfoBlock/ContactInfoBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';
import * as translation from '@/utils/TranslationComponent/translation.utilities'

export interface IBlockInputProps {
    items: {
        icon?: string;
        link?: any;
        text?: string
    }[];
    [key: string]: any;
}

const mapInputToProps = (input: IBlockInputProps): IBlockProps => {
    const { items, ...rest } = input;
    return {
        items: items
            .map(item => {
                const { icon, link, text } = item;

                if (!link && !text) {
                    return undefined; // Skip items without link or text
                }

                return {
                    icon: icon as IBlockProps['items'][number]['icon'],
                    html: link ? translation.mapAnchorProps(link) : text ? text : 'Not text give'
                };
            })
            .filter((item): item is NonNullable<typeof item> => !!item),
        ...rest, // Pass through BlockWrapper related settings
    };
};

const BlockTranslation: React.FC<IBlockInputProps> = (inputProps) => {
    return (
        <TranslationComponent
            inputProps={inputProps}
            TargetComponent={ContactInfoBlock}
            mapProps={mapInputToProps}
        />
    );
};

export default BlockTranslation;
